import { ArrowIcon } from "assets/icons";
import { If } from "components";
import { BoxShadowLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon } from "ui";

import { StatisticsBlockLayoutProps } from "./StatisticsBlockLayout.types";

import styles from "./StatisticsBlockLayout.module.scss";

const StatisticsBlockLayout = ({
  title,
  titleAdditional,
  navigationPass,
  navigationOptions,
  onShowAll,
  children
}: StatisticsBlockLayoutProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BoxShadowLayout className={styles.layout}>
      <div className={styles.layout__header}>
        <p className={styles["layout__header--title"]}>
          {t(title)}{" "}
          <If condition={!!titleAdditional}>
            <span className={styles["layout__header--title-span"]}>
              ({titleAdditional ? t(titleAdditional) : null})
            </span>
          </If>
        </p>
        <button
          onClick={() => {
            if (navigationPass) navigate(navigationPass, navigationOptions);
            onShowAll?.();
          }}
          className={styles["layout__header--link"]}
        >
          {t("Show All")}
          <Icon
            as={ArrowIcon}
            boxSize={18}
            className={styles["layout__header--link-icon"]}
          />
        </button>
      </div>

      {children}
    </BoxShadowLayout>
  );
};

export default StatisticsBlockLayout;
